import React from 'react';
import '../styles/theme.css';
import '../styles/SignUp.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SignUpAccountExplanation from '../components/SignUpAccountExplanation';
import SignUpEnrollmentPanel from '../components/SignUpEnrollmentPanel';
/* IMPORTS */

function SignUpPage() {
  return (
    <div className="si-root">
      <div className="si-layout-1">
        <div id="signupnavbarslot" className="si-slot-signupnavbarslot">
          <Navbar activePage={"Sign Up"} />
        </div>
        <div className="si-layout-2">
          <div id="signupenrollmentpanel" className="si-slot-signupenrollmentpanel">
            <SignUpEnrollmentPanel />
          </div>
          <div id="signupaccountexplanation" className="si-slot-signupaccountexplanation">
            <SignUpAccountExplanation />
          </div>
        </div>
        <div id="signupfooterslot" className="si-slot-signupfooterslot">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default SignUpPage;